import { render } from "./Intensive.vue?vue&type=template&id=3333681c"
import script from "./Intensive.vue?vue&type=script&lang=js"
export * from "./Intensive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__